import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { computed, type Component } from "vue";
import { useOffcanvasStore } from "@/store/useOffcanvasStore";
import { toggleOffcanvas } from "@/utils/Helper";
import { OffcanvasViewKey, Views } from "./OffcanvasViewsConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'OffcanvasViews',
  setup(__props) {

const store = useOffcanvasStore();

const View = computed<Component | null>(
  () => Views[store.config?.path as OffcanvasViewKey] || null,
);
const viewProps = computed(() => store.config?.props ?? null);
const title = computed(() => store.config?.title ?? "");

function offcanvasClosed() {
  if (store.history.length === 1) {
    toggleOffcanvas("offcanvas_views");
    setTimeout(() => {
      store.clear();
      store.popHistory();
    }, 200);
  } else {
    store.popHistory();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_OffcanvasComponent = _resolveComponent("OffcanvasComponent")!

  return (_openBlock(), _createBlock(_component_OffcanvasComponent, {
    id: `offcanvas_views`,
    title: title.value,
    onOffcanvasClosed: offcanvasClosed
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(View.value), _normalizeProps(_guardReactiveProps(viewProps.value)), null, 16))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})